import { render, staticRenderFns } from "./GroupsByNotification.vue?vue&type=template&id=47abe628&scoped=true&"
import script from "./GroupsByNotification.vue?vue&type=script&lang=js&"
export * from "./GroupsByNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47abe628",
  null
  
)

export default component.exports